
import axios from "axios";


//search AGA details 
export const search_aga = async (inputs:any) => {}

export const search_zip = async (zipcode:any) => {
    
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/search_hs_zipcode",
        data: {
            'zipcode': zipcode
        },
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}






export const get_golfer_profile = async (contact_guid:any) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/get_golfer_profile",
        data: {
            'contact_guid': contact_guid
        },
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}




export const get_golfer_deals = async (contact_guid:any) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/get_golfer_deals",
        data: {
            'contact_guid': contact_guid
        },
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          //console.error(error);
          return JSON.stringify({error: error});
 
      })
}





export const access_golfer = async (inputs:any) => {
    
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/access_lookup",
        data: {
            'lastname': inputs.lastname,
            'emailaddress': inputs.email,
            'handicapID': inputs.handicapID
        },
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        //.log("REPSOND " + response);
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
         // console.error(error);
          return JSON.stringify({error: error});
 
      })
}



//search / verify golfer
export const resend_code = async (inputs:any, aga_id:any, agadata:any) => {


    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/resend_golfer_code",
        data: {
            'lastname': inputs.lastname,
            'emailaddress': inputs.email,
            'handicapID': inputs.handicapID,
            'agadata': agadata
        },
        withCredentials: true       
    }
    
    return await axios.request(options)
      .then(function(response) {
       
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}






//search / verify golfer
export const search_golfer = async (inputs:any, aga_id:any, agadata:any) => {


    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/search_golfer_v2",
        data: {
            'lastname': inputs.lastname,
            'emailaddress': inputs.email,
            'handicapID': inputs.handicapID,
            'agadata': agadata
        },
        withCredentials: true
        
    }
    
    return await axios.request(options)
      .then(function(response) {
       
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          //console.error(error);
          return JSON.stringify({error: error});
 
      })
}


export const verify_golfer = async (field:any, otp:any, inputs: any, propertyUsed:any, agadata:any) => {
  
    let hubspotField='';

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/verify_golfer",
        data: {
            'field': field,
            'otp': otp,
            'golfer': inputs,
            'propertyUsed': propertyUsed,
            'agadata': agadata
        }        
    }
    return await axios.request(options)
      .then(function(response) {

         return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}



export const verify_membership_golfer = async (otp:any, inputs: any) => {
  
    let hubspotField='';

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/verify_membership_access",
        data: {
            'otp': otp,
            'contact_guid': inputs,
        }        
    }
    return await axios.request(options)
      .then(function(response) {

         return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}


export const update_hs_cart_stage = async (agaData:any, stage:any, result:any, payment:any) => {


    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/update_custom_stage",
        data: {
           'agadata': agaData,
            "stage": stage,
            "result": result,
            "payment": payment             
        }        
    }
    return await axios.request(options)
      .then(function(response) {

         return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}


export const pre_payment = async (agaData:any, stage:any, result:any, payment:any) => {


    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/pre_payment_error_log",
        data: {
           'agadata': agaData,
            "stage": stage,
            "result": result,
            "payment": payment             
        }        
    }
    return await axios.request(options)
      .then(function(response) {

         return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}








/*

export const newGolfer2 = async () => {
    const golfer = JSON.parse(sessionStorage.getItem("person") || '');
    const aga = JSON.parse(sessionStorage.getItem("aga") || '[]');

    console.log("email " + golfer.email);

    try {
        const property1 = { email: golfer.email};
        const response1 = await axios.post('http://localhost:3001/search_golfer', { property1});
    
        if (response1.data)
        {
        
        } else {

        }
        const response2 = await axios.post('/api/endpoint2', { data: 'for endpoint 2', response1Data: response1.data });
        console.log('Response 2:', response2.data);
    
      } catch (error) {
        console.error('Error:', error);
      }

}
*/

export const copy_cc_golfer = async (golfer:any, agadata:any, response:any) => {
 
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/copy_cc_golfer_to_hubspot",
        data: {
            'lastname': golfer.lastname,
            'email': golfer.email || response.email,
            'handicapID': golfer.handicapID,
            'aga_id': agadata[0].aga_id,
            'zip': agadata[0].zipcode,
            'cc_response': response
        }
    }
    return await axios.request(options)
      .then(function(response) {
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}


export const get_golfer_memberships_data = async (contact_guid:any) => {
    
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/manage_club_memberships",
        data: {
            'contact_guid': contact_guid
        }
    }
    return await axios.request(options)
      .then(function(response) {
           
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}


export const get_golfer_memberships = async (golfer_id:any) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/get_club_memberships",
        data: {
            'handicap_id': golfer_id
        }
    }
    return await axios.request(options)
      .then(function(response) {
           
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}   


export const getGolferMemberships = async (contact_guid:any, dealid:any) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/getGolferMemberships",
        data: {
            'contact_guid': contact_guid,
            'dealId': dealid
        }
    }
    return await axios.request(options)
      .then(function(response) {
           
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}   


export const updatePaymentMethod = async (stripe_customer:any, stripe_payment_token:any, subscription_token:any, dealid:any) => {


    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/updateStripePaymentMethod",
        data: {
            'stripe_customer': stripe_customer,
            'stripe_payment_token': stripe_payment_token,
            'stripe_subscription_token': subscription_token,
            'dealid': dealid
        }
    }
    return await axios.request(options)
      .then(function(response) {
           
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}   





export const updateMembership = async (dealId: any, cancelOption:any, cancelReason:any, comments:any, handicap_id:any) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/updateGolferMembership",
        data: {
            'dealId': dealId,
            'cancelOption': cancelOption,
            'cancel_reason': cancelReason,
            'comments': comments,
            'handicap_id': handicap_id
        }
    }
    return await axios.request(options)
      .then(function(response) {
           
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}


export const refundMembership = async (dealId: any, refundReason:any, comments:any, handicap_id:any) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/refundMembership",
        data: {
            'dealId': dealId,
            'refundReason': refundReason,
            'comments': comments,
            'handicap_id': handicap_id
        }
    }
    return await axios.request(options)
      .then(function(response) {
           
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}







export const update_golfer_access = async (golfer:any) => {


    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/update_golfer",
        data: {
            'lastname': golfer.lastname,
            'email': golfer.email,
            'handicapID': golfer.handicapID
        }
    }
    return await axios.request(options)
      .then(function(response) {
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
}




export const updateMemberGolferProfile = async (golfer:any) => {



   const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/updateMemberGolfer",
        data: {
            'contact_guid': golfer.contact,
            'firstname': golfer.firstname,
            'lastname': golfer.lastname,
            'email': golfer.email,
            'phone': golfer.phone,
            'date_of_birth': golfer.dob,
            'gender': golfer.sex,
            'city': golfer.city,
            'hs_state_code': golfer.state,
            'zip': golfer.zip
        }
    }
    return await axios.request(options)
      .then(function(response) {
          //setData(response.data)
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
};





export const updateGolferProfile = async (aga:any, golfer:any, pagename:any) => {

   const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/update_golfer_profile",
        data: {
            'firstname': golfer.firstname,
            'lastname': golfer.lastname,
            'email': golfer.email,
            'phone': golfer.phone,
            'date_of_birth': golfer.dob,
            'gender': golfer.sex,
            'address': golfer.address,
            'city': golfer.city,
            'hs_state_code': golfer.state,
            'zip': golfer.zip,
            'address2': golfer.address2,
            'aga_id': aga[0].aga_id,
            'mode': "create",
            'search_metric_id': aga[0].search_metric_id,
            'company': aga[0].company,
            'contact_guid': golfer.contact,
            'pagename': pagename

        }
    }
    return await axios.request(options)
      .then(function(response) {
          //setData(response.data)
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
};


export const createNewGolferSubscription = async (paymentmethod:any, aga:any, golfer:any) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/create_subscription",
        data: {
            'firstname': golfer.firstname,
            'lastname': golfer.lastname,
            'payment_method': paymentmethod,
            'phone': golfer.phone,
            'email': golfer.email,
            'sex': golfer.sex,
            'state': golfer.state,
            'zip': golfer.zip,
            'address': golfer.address,
            'address2': golfer.address2,
            'city': golfer.city,
            'dob': golfer.dob, 
            'aga_id': aga[0].aga_id,
            'aga_club_name': aga[0].aga_club_name,
            'autorenew': golfer.autorenew,
            'usga_terms': golfer.usgaTerms,
            'aga_terms': golfer.agaTerms
        }
    }
    return await axios.request(options)
      .then(function(response) {
          
          return JSON.stringify(response.data);
      })
      .catch(function (error) {
          console.error(error);

      })
}



export const create_stripe_customer = async (paymentmethod:any, aga:any, golfer:any) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/create_subscription",
        data: {
            'golfer': golfer,
            'aga': aga[0],
            'payment_method': paymentmethod
        }
    }
    return await axios.request(options)
      .then(function(response) {
          
          return JSON.stringify(response.data);
      })
      .catch(function (error) {
          console.error(error);

      })
}

export const check_stripe_transaction = async (aga:any, golfer:any) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/check_duplciate_stripe_transaction",
        data: {
            'golfer': golfer,
            'aga': aga[0]
        }
    }
    return await axios.request(options)
      .then(function(response) {
          
          return JSON.stringify(response.data);
      })
      .catch(function (error) {
          console.error(error);

      })
}











export const updateGolfer = async (golferid:any) => {
    const golfer = JSON.parse(sessionStorage.getItem("person") || '');
    const aga = JSON.parse(sessionStorage.getItem("aga") || '[]');


   const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/create_new_contact",
        data: {
            'firstname': golfer.firstname,
            'lastname': golfer.lastname,
            'email': golfer.email,
            'phone': golfer.phone,
            'date_of_birth': golfer.dob,
            'gender': golfer.sex,
            'address': golfer.address,
            'address2': golfer.address2,
            'city': golfer.city,
            'hs_state_code': golfer.state,
            'zip': golfer.zip,
            'aga_id': aga[0].aga_id,
            'contactid': golfer.contactid,
            'mode': "update",
            'golfer_id': golferid
        }
    }
    return await axios.request(options)
      .then(function(response) {
          //setData(response.data)
       
          const contactid = response.data.id;
       
          golfer.contactid = contactid;
          sessionStorage.setItem('person', JSON.stringify(golfer));
          //sessionStorage.setItem('person', JSON.stringify(golfer));
          //console.log(response.data);
          return JSON.stringify(response.data);
          
      })
      .catch(function (error) {
          console.error(error);

      })
};


export const encode = async () => {
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST+"/get_session",
        data: {
            'words': 'hello world'
        }
    }
    await axios.request(options)
      .then(function(response) {
    
        return response.data;
      })
      .catch(function (error) {
          console.error(error);

      })
};